import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthRequestOptions } from '@ntap/core';
import { Observable } from 'rxjs';

import { AppConfig, appConfigService } from '@app/config';

export interface OibResponse {
  oib: string | null;
}

@Injectable({ providedIn: 'root' })
export class OibService {
  constructor(
    @Inject(appConfigService) private config: AppConfig,
    private http: HttpClient
  ) {}

  /**
   * Pretraži osobu po OIB-u
   * @param oib OIB osobe
   * @param naturalOnly Ako je true, pretražuje samo fizičke osobe
   */
  searchPerson(oib: string, naturalOnly = false): Observable<any> {
    const endpoint = naturalOnly
      ? 'oib-service/person/natural/'
      : 'oib-service/person/';
    return this.http.get(
      this.config.apiHost + endpoint + oib,
      new AuthRequestOptions()
    );
  }

  /**
   * Dohvati OIB za agenta
   * @param agentId ID agenta
   */
  getAgentOib(agentId: string): Observable<OibResponse> {
    return this.http.get<OibResponse>(
      this.config.apiHost + 'oib-service/agent/' + agentId,
      new AuthRequestOptions()
    );
  }

  /**
   * Primijeni OIB podatke za agenta
   * @param agentId ID agenta
   * @param oib OIB
   */
  applyForAgent(agentId: string, oib: string): Observable<any> {
    return this.http.post(
      this.config.apiHost + `oib-service/${agentId}/${oib}`,
      null,
      new AuthRequestOptions()
    );
  }

  /**
   * Primijeni OIB podatke za registriranog korisnika
   * @param oib OIB
   * @param korisnikId ID korisnika (opcionalno)
   */
  applyForKorisnik(oib: string, korisnikId?: string): Observable<any> {
    let params = new HttpParams();
    if (korisnikId) {
      params = params.set('korisnikId', korisnikId);
    }
    return this.http.get(this.config.apiHost + 'oib-service/korisnik/' + oib, {
      ...new AuthRequestOptions(),
      params
    });
  }

  /**
   * Primijeni OIB podatke za subjekt
   * @param oib OIB
   * @param subjektId ID subjekta (opcionalno)
   */
  applyForSubjekt(oib: string, subjektId?: string): Observable<any> {
    let params = new HttpParams();
    if (subjektId) {
      params = params.set('subjektId', subjektId);
    }
    return this.http.get(this.config.apiHost + 'oib-service/subjekt/' + oib, {
      ...new AuthRequestOptions(),
      params
    });
  }
}
